export class GeneralResponse {
  constructor({ id, data, resultCode, resultDescription, traceId, urlRedirect }) {
    if (!resultCode) {
      throw new Error('Result code is required');
    }
    this.id = id;
    this.data = data;
    this.resultCode = resultCode;
    this.resultDescription = resultDescription;
    this.traceId = traceId;
    this.urlRedirect = urlRedirect;
  }
}
